/* Hook puente entre el estado mutable de Boston IA y React.
   Cualquier vista que lo use se re-renderiza cuando la logica original llama emit(). */

import { useEffect, useReducer } from 'react'
import { state, subscribe, emit } from './store'

export function useBostonState() {
  const [, force] = useReducer((n) => n + 1, 0)
  useEffect(() => subscribe(force), [])
  return state
}

export { emit }
